// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Micronesia from '../_raw/flag/icon_flag_micronesia.png';

export default () => <img src={Micronesia} alt="Micronesia" />;
